export interface IState {
  roles: any;
  rolesCount: number;
  tax: any;
  adminSettingData: any;
  haulCompanyData: any;
  boatCount: any;
  sidebarCount: any;
  networkRefreshModalCount: number;
}

type Action = any;

export const adminSettingsReducer = (
  state: IState = {
    roles: [],
    rolesCount: 0,
    tax: 0,
    adminSettingData: {},
    haulCompanyData: [],
    boatCount: 0,
    sidebarCount: {},
    networkRefreshModalCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_ROLES":
      return {
        ...state,
        roles: action?.payload?.data,
        rolesCount: action?.payload?.count,
      };
    case "CLEAR_ROLES_DATA":
      return {
        ...state,
        roles: [],
      };
    case "RESTORE_ROLE_DELETE":
      return {
        ...state,
        roles: state?.roles?.filter(
          (elem: any) => elem?._id !== action?.payload
        ),
      };
    case "GET_TAX":
      return {
        ...state,
        tax: action?.payload,
      };
    case "GET_ADMIN_SETTING_DATA":
      return {
        ...state,
        adminSettingData: action?.payload,
      };
    case "DELETE_ROLE":
      return {
        ...state,
        roles: state?.roles?.filter((elem: any) => elem._id != action.payload),
      };
    case "GET_HAUL_COMPANY":
      return {
        ...state,
        haulCompanyData:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.haulCompanyData, ...action?.payload?.data],
      };
    case "UPDATE_HAUL_COMPANY":
      return {
        ...state,
        haulCompanyData: state?.haulCompanyData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_HAUL_COMPANY":
      return {
        ...state,
        haulCompanyData: state?.haulCompanyData?.filter(
          (elem: any) => elem?._id !== action?.payload
        ),
      };
    case "RESTORE_PERMENENT_DELETE_HAUL_COMPANY":
      return {
        ...state,
        haulCompanyData: state?.haulCompanyData?.filter(
          (elem: any) => elem?._id !== action?.payload
        ),
      };
    case "GET_BOAT_COUNT":
      return {
        ...state,
        boatCount: action?.payload,
      };
    case "GET_SIDEBAR_COUNT":
      return {
        ...state,
        sidebarCount: action?.payload,
      };
    case "INCREMENT_NETWORK_MODAL_COUNT":
      return {
        ...state,
        networkRefreshModalCount: state.networkRefreshModalCount + 1,
      };
    case "RESET_NETWORK_MODAL_COUNT":
      return {
        ...state,
        networkRefreshModalCount: 0,
      };

    default:
      return state;
  }
};
